import {
  TIMESERIES_LIST_REQUEST,
  TIMESERIES_LIST_SUCCESS,
  TIMESERIES_LIST_FAIL,
  SET_ACTIVE_TIMESCALE,
} from '../constants/TimeSeriesConstants';

export const timeSeriesReducer = (
  state = { data: [], activeTimescale: 'All' },
  action
) => {
  switch (action.type) {
    case TIMESERIES_LIST_REQUEST:
      return { ...state, loading: true, data: [] };
    case TIMESERIES_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case TIMESERIES_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    case SET_ACTIVE_TIMESCALE:
      return { ...state, activeTimescale: action.payload };
    default:
      return state;
  }
};
